import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Brain,
  PenLine,
  NotebookPen,
  Ruler,
  Bus,
  Crown,
  Pill,
  FlaskConical,
  Monitor,
  Palette,
  Languages,
  HeartPulse,
  Camera,
  BookOpenCheck,
  GraduationCap,
  ArrowLeft,
  ArrowRight,
} from "lucide-react";

import "./Services.css";

function Services() {
  const { t, i18n } = useTranslation();

  const isArabic =
    i18n.resolvedLanguage === "ar" ||
    i18n.language?.startsWith("ar");

  const services = [
    {
      id: 1,
      icon: Brain,
      color: "red",
      title: t("services.service1Title"),
      description: t("services.service1Text"),
    },
    {
      id: 2,
      icon: PenLine,
      color: "blue",
      title: t("services.service2Title"),
      description: t("services.service2Text"),
    },
    {
      id: 3,
      icon: NotebookPen,
      color: "yellow",
      title: t("services.service3Title"),
      description: t("services.service3Text"),
    },
    {
      id: 4,
      icon: Ruler,
      color: "red",
      title: t("services.service4Title"),
      description: t("services.service4Text"),
    },
    {
      id: 5,
      icon: Bus,
      color: "blue",
      title: t("services.service5Title"),
      description: t("services.service5Text"),
    },
    {
      id: 6,
      icon: Crown,
      color: "yellow",
      title: t("services.service6Title"),
      description: t("services.service6Text"),
    },
    {
      id: 7,
      icon: Pill,
      color: "red",
      title: t("services.service7Title"),
      description: t("services.service7Text"),
    },
    {
      id: 8,
      icon: FlaskConical,
      color: "blue",
      title: t("services.service8Title"),
      description: t("services.service8Text"),
    },
    {
      id: 9,
      icon: Monitor,
      color: "yellow",
      title: t("services.service9Title"),
      description: t("services.service9Text"),
    },
    {
      id: 10,
      icon: Palette,
      color: "red",
      title: t("services.service10Title"),
      description: t("services.service10Text"),
    },
    {
      id: 11,
      icon: Languages,
      color: "blue",
      title: t("services.service11Title"),
      description: t("services.service11Text"),
    },
    {
      id: 12,
      icon: HeartPulse,
      color: "yellow",
      title: t("services.service12Title"),
      description: t("services.service12Text"),
    },
    {
      id: 13,
      icon: Camera,
      color: "red",
      title: t("services.service13Title"),
      description: t("services.service13Text"),
    },
    {
      id: 14,
      icon: BookOpenCheck,
      color: "blue",
      title: t("services.service14Title"),
      description: t("services.service14Text"),
    },
    {
      id: 15,
      icon: GraduationCap,
      color: "yellow",
      title: t("services.service15Title"),
      description: t("services.service15Text"),
    },
  ];

  return (
    <main
      className={`services-page ${
        isArabic ? "rtl" : "ltr"
      }`}
      dir={isArabic ? "rtl" : "ltr"}
    >
      {/* ================= HERO ================= */}

      <section className="services-hero">

        <div className="services-shape services-red"></div>
        <div className="services-shape services-blue"></div>
        <div className="services-shape services-yellow"></div>

        <div className="services-hero-content">

          <span className="services-tag">
            {t("services.tag")}
          </span>

          <h1>
            {t("services.heroTitle")}
            <br />

            <span>
              {t("services.heroHighlight")}
            </span>
          </h1>

          <p>
            {t("services.heroText")}
          </p>

        </div>

      </section>

      {/* ================= SERVICES ================= */}

      <section className="services-section">

        <div className="services-container">

          <div className="services-heading">

            <div>
              <span className="section-label">
                {t("services.listTag")}
              </span>

              <h2>
                {t("services.listTitle")}
              </h2>
            </div>

            <p>
              {t("services.listText")}
            </p>

          </div>

          <div className="services-grid">

            {services.map((service) => {

              const Icon = service.icon;

              return (
                <article
                  className={`service-card ${service.color}`}
                  key={service.id}
                >

                  <div className="service-number">
                    {String(service.id).padStart(2, "0")}
                  </div>

                  <div className="service-icon">
                    <Icon size={30} strokeWidth={2} />
                  </div>

                  <h3>
                    {service.title}
                  </h3>

                  <p>
                    {service.description}
                  </p>

                  <Link
                    to="/registration"
                    className="service-link"
                  >
                    <span>
                      {t("services.register")}
                    </span>

                    {isArabic ? (
                      <ArrowLeft size={18} />
                    ) : (
                      <ArrowRight size={18} />
                    )}
                  </Link>

                </article>
              );

            })}

          </div>

        </div>

      </section>

      {/* ================= CTA ================= */}

      <section className="services-cta">

        <div className="cta-decoration cta-red"></div>
        <div className="cta-decoration cta-yellow"></div>

        <div className="services-cta-content">

          <span>
            {t("services.ctaTag")}
          </span>

          <h2>
            {t("services.ctaTitle")}
          </h2>

          <p>
            {t("services.ctaText")}
          </p>

          <Link
            to="/registration"
            className="services-cta-button"
          >
            {t("services.ctaButton")}

            {isArabic ? (
              <ArrowLeft size={20} />
            ) : (
              <ArrowRight size={20} />
            )}
          </Link>

        </div>

      </section>

    </main>
  );
}

export default Services;